import React from 'react';
import { Text } from '../../../../../../../ui-kit';








const VoiceOverModalV3Content = () => {
  const MODAL_CONTENT = [
  {
    id: 'fist-paragraph',
    text: 'The below rates are ',
    highlighted: 'INDICATIVE ONLY. ',
    rest:
    'You will be contacted to confirm costs based off your script and usage type if amount exceeds the estimates below.'
  },
  {
    id: 'second-paragraph',
    text: 'A Voice Over may add up to 48 hours to your turnaround time.'
  },
  {
    id: 'third-paragraph',
    text: 'Rates shown pertain to ',
    highlighted: 'Basic Internet use licensing only. ',
    rest:
    'Licensing for other usage such as advertising or promotions will incur additional fees. Speak to us about your use case.'
  },
  {
    id: 'fourth-paragraph',
    text: '2x re-records included for changes in tone or style. ',
    highlighted: 'Revision fees apply for script changes.'
  }];


  const content = MODAL_CONTENT.map(
    ({ highlighted = '', rest = '', text, id }) =>
    <Text key={id} body noMargin className="voice-over-modal__subtitle">
        {text}
        {highlighted &&
      <span className="voice-over-modal__subtitle__text">
            {highlighted}
          </span>}

        {rest}
      </Text>

  );

  return <>{content}</>;
};

export default VoiceOverModalV3Content;